import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import styled, { css } from 'styled-components';
import { Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const MaxWidthContainer = styled(DishFirstExploreWidthLimit)`
  margin-top: ${Spacing.SINGLE_HALF};
  margin-bottom: ${Spacing.QUADRUPLE};

  &:only-child {
    margin-top: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${Spacing.NONE} ${Spacing.SINGLE};
  justify-content: space-between;

  margin-bottom: ${Spacing.SINGLE_HALF};
  cursor: default;
`;

export const Collection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${Spacing.SINGLE};
  padding: ${Spacing.NONE} ${Spacing.SINGLE};

  ${Mixins.Media.maxWidthMedium(css`
    grid-template-columns: 1fr 1fr;
  `)}

  ${Mixins.Media.maxWidthSmall(css`
    grid-template-columns: 1fr;
  `)}

  ${Mixins.Media.minWidthSmall(css`
    gap: ${Spacing.SINGLE_HALF};
  `)}

  & > * {
    box-shadow: 10px 16px 30px rgba(0, 0, 0, 0.1);
  }
`;

export const CollectionTitle = styled.h1`
  padding: ${Spacing.NONE} ${Spacing.SINGLE} ${Spacing.THREE_QUARTERS};
  font-size: ${Font.Size.XXL};
  font-weight: ${Font.Weight.BOLD};

  ${Mixins.Media.maxWidthMedium(css`
    font-size: ${Font.Size.L};
  `)}
`;

export const CollectionContainer = styled.div`
  position: relative;
  min-height: 60vh;
`;

export const CollectionAnchor = styled.div`
  position: relative;
  top: -120px;
`;

export const DividerContainer = styled.div`
  width: 100%;
  height: ${Spacing.HALF};
  position: relative;
  margin: ${Spacing.TRIPLE} 0 ${Spacing.DOUBLE};
  color: ${Colors.GRAY_LITE_10};

  & path {
    stroke-width: 8;
  }
`;
